var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoft = function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#microsoft_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.783 3.783h7.826v7.826H3.783V3.783Z",
    fill: "#F35325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.391 3.783h7.826v7.826h-7.826V3.783Z",
    fill: "#81BC06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.783 12.391h7.826v7.826H3.783v-7.826Z",
    fill: "#05A6F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.391 12.391h7.826v7.826h-7.826v-7.826Z",
    fill: "#FFBA08"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "microsoft_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3 3)",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgMicrosoft;